import Row from '@components/row'
import SvgImage from '@components/svg'
import Typography from '@components/typography'
import theme from '@utils/theme'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import useWindowSize from '@hooks/useWindow'

interface IGoBack {
  title?: string
  tc?: keyof typeof theme.colors
  visibleForDesktop?: boolean
}

const GoBack = ({
  title,
  tc = 'primary',
  visibleForDesktop = true,
}: IGoBack) => {
  const navigate = useNavigate()
  const { width } = useWindowSize()
  const isPhoneScreen = width < 1024

  if (!isPhoneScreen && !visibleForDesktop) {
    return null
  }

  return (
    <Row>
      <Row
        onClick={() => navigate(-1)}
        styleRow={{
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          width: 'auto',
          padding: '8px 0 16px 0',
        }}
      >
        <SvgImage src="leftArrow" />
        <Typography content={title || ''} tc={tc} />
      </Row>
    </Row>
  )
}

export default GoBack
